
import { useTranslation } from "pro-features/components/WithTranslation";

import { AllCompetitorsModal } from "../components/AllCompetitorsModal";
import { AllCompetitorsModalProvider } from "../components/AllCompetitorsModalContext";
import { WidgetCard } from "../WidgetCard";

import { ShareOfChannelTraffic, ShareOfChannelTrafficCompetitorsTable } from "./components";

export const ShareOfChannelTrafficContainer = () => {
    const translate = useTranslation();

    const actions = (
        <AllCompetitorsModal>
            <ShareOfChannelTrafficCompetitorsTable />
        </AllCompetitorsModal>
    );

    return (
        <AllCompetitorsModalProvider>
            <WidgetCard
                subtitle={translate("bt.report.channels.share-of-channel-traffic-table.subtitle")}
                title={translate("bt.report.channels.share-of-channel-traffic-table.title")}
                automationIds={{
                    title: "share-of-channel-traffic-title",
                    body: "share-of-channel-traffic-body",
                }}
                actions={actions}
            >
                <ShareOfChannelTraffic />
            </WidgetCard>
        </AllCompetitorsModalProvider>
    );
};
